import { NewJourneyNotificationModalTranslations } from "./new-journey-notification-modal-pt-br";

export const NEW_JOURNEY_NOTIFICATION_MODAL_FR_FR: NewJourneyNotificationModalTranslations = {
	title: "Votre parcours de retrait est devenu plus simple",
	content:
		"Zig a unifié les parcours de retrait et d'anticipation en un seul flux, apportant plus d'agilité à ceux qui doivent accéder aux ressources de l'opération. Cliquez sur \"Voir Portefeuille\" et essayez le nouveau parcours.",
	primaryActionLabel: "Fermer",
};
